import { createLink, useRouter } from '@tanstack/react-router';
import { Explore } from '@gympass/tai-chi/illustrations';
import { type ComponentProps, useEffect } from 'react';

import { Button } from 'components/atoms/Button';
import { InfoPage } from 'components/templates/InfoPage';
import { useLocalization } from 'providers/LocalizationProvider';
import { rumService } from 'services/rum';

const CreatedLinkComponent = createLink(Button);

function ButtonLink(props: ComponentProps<typeof CreatedLinkComponent>) {
  return <CreatedLinkComponent preload="intent" {...props} />;
}

export function NotFoundError() {
  const { t } = useLocalization();
  const router = useRouter();

  useEffect(
    function syncNavigationWithRumLog() {
      const unsubscribe = router.subscribe(
        'onBeforeNavigate',
        ({ fromLocation }) => {
          rumService.addAction('user navigate to home from not found page', {
            fromLocation,
          });
        },
      );
      return unsubscribe;
    },
    [router],
  );

  return (
    <InfoPage
      title={t('not_found_error_page.title')}
      subtitle={t('not_found_error_page.subtitle')}
      illustrationSvgElement={<Explore />}
    >
      <ButtonLink to="/" replace>
        {t('not_found_error_page.cta')}
      </ButtonLink>
    </InfoPage>
  );
}
